var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCurrentLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5.625C7.99594 5.625 4.75 8.87094 4.75 12.875C4.75 16.8791 7.99594 20.125 12 20.125C16.0041 20.125 19.25 16.8791 19.25 12.875C19.25 8.87094 16.0041 5.625 12 5.625ZM3.25 12.875C3.25 8.04251 7.16751 4.125 12 4.125C16.8325 4.125 20.75 8.04251 20.75 12.875C20.75 17.7075 16.8325 21.625 12 21.625C7.16751 21.625 3.25 17.7075 3.25 12.875Z",
    fill: "#222729"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8.625C11.5858 8.625 11.25 8.28921 11.25 7.875L11.25 4.875C11.25 4.46079 11.5858 4.125 12 4.125C12.4142 4.125 12.75 4.46079 12.75 4.875L12.75 7.875C12.75 8.28921 12.4142 8.625 12 8.625Z",
    fill: "#222729"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 17.125C12.4142 17.125 12.75 17.4608 12.75 17.875L12.75 20.875C12.75 21.2892 12.4142 21.625 12 21.625C11.5858 21.625 11.25 21.2892 11.25 20.875L11.25 17.875C11.25 17.4608 11.5858 17.125 12 17.125Z",
    fill: "#222729"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.75 12.875C20.75 13.2892 20.4142 13.625 20 13.625L17 13.625C16.5858 13.625 16.25 13.2892 16.25 12.875C16.25 12.4608 16.5858 12.125 17 12.125L20 12.125C20.4142 12.125 20.75 12.4608 20.75 12.875Z",
    fill: "#222729"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 12.875C3.25 12.4608 3.58579 12.125 4 12.125H7C7.41421 12.125 7.75 12.4608 7.75 12.875C7.75 13.2892 7.41421 13.625 7 13.625H4C3.58579 13.625 3.25 13.2892 3.25 12.875Z",
    fill: "#222729"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentLocation);
export default __webpack_public_path__ + "static/media/current-location.309ca4a9190f361322701903f5bf83f6.svg";
export { ForwardRef as ReactComponent };